export class AddApplicant {
    constructor (
        public RentalApplicationKey: number = null,
        public InvitedByApplicantKey: number = 0,
        public RentalApplicantKey: number = 0,
        public FirstName: string = '',
        public LastName: string = '',
        public FullName: string = '',
        public HomePhone: string = '',
        public CellPhone: string = '',
        public Email: string = '',
        public IsNonLeaseHolderOccupant: boolean = false,
        public IsGuarantor: boolean = false
    ) { }
}
